import {
  Cancel01Icon,
  CheckmarkBadge01Icon,
  Loading03Icon
} from "@hugeicons-pro/core-solid-rounded";
import { Tick02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { IconSvgElement } from "@hugeicons/react";
import { BadgeVariant } from "shared/components";
import { ApplicationStatus, VerificationStatus } from "shared/types";

export const OCROLUS_FAIL_STATUSES = ["UNABLE_TO_PROCESS", "UNSUPPORTED"];

export const INCOME_STATUSES = {
  failed: "Rejected",
  verified_with_warnings: "Warning",
  verified: "Accepted",
  manually_verified: "Manually verified",
  in_progress: "In progress",
  completed_with_override: "Completed with override"
};

type IncomeSourceBadge = {
  variant: BadgeVariant;
  title: string;
  icon?: IconSvgElement;
  iconSize?: number;
  iconColor?: string;
  tooltip?: string;
};

export const INCOME_SOURCE_BADGE_STATUSES_MAP: {
  [key: string]: IncomeSourceBadge;
} = {
  Rejected: {
    variant: BadgeVariant.ERROR,
    title: "Rejected",
    icon: Cancel01Icon,
    iconSize: 16,
    iconColor: "text-danger-500"
  },
  Warning: {
    variant: BadgeVariant.WARNING,
    title: "Verified with warnings",
    icon: CheckmarkBadge01Icon,
    iconSize: 12,
    iconColor: "text-warning-500"
  },
  Accepted: {
    variant: BadgeVariant.SUCCESS,
    title: "Verified",
    icon: CheckmarkBadge01Icon,
    iconSize: 12,
    iconColor: "text-success-600"
  },
  NoTransactions: {
    variant: BadgeVariant.BASE,
    title: "No transactions selected"
  },
  Started: {
    variant: BadgeVariant.WARNING,
    title: "In progress",
    icon: Loading03Icon,
    iconSize: 12,
    iconColor: "text-warning-500"
  },
  Overridden: {
    variant: BadgeVariant.BASE,
    title: "Completed with override",
    icon: Tick02Icon,
    iconSize: 12,
    iconColor: "text-content-400",
    tooltip: "Verification manually marked as complete"
  }
};

export const INCOMPLETE_VERIFICATION_STATUSES = [
  VerificationStatus.Pending,
  VerificationStatus.Started,
  VerificationStatus.Processing
];

export const INCOMPLETE_APPLICATION_STATUSES = [
  ApplicationStatus.Pending,
  ApplicationStatus.Started,
  ApplicationStatus.PartiallySubmitted
];
